var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5728C18.0751 23.5728 23 18.5197 23 12.2864C23 6.0531 18.0751 1 12 1C5.92487 1 1 6.0531 1 12.2864C1 18.5197 5.92487 23.5728 12 23.5728Z",
    fill: "#37C7BE",
    stroke: "#37C7BE",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 7 16.1949 5.40763 18 6.24168",
    stroke: "#207F79",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10 5 8.42385 5 6 5",
    stroke: "#207F79",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72543 14.9878C7.72543 14.9878 9.76844 16.8207 12.4314 15.2188",
    stroke: "#207F79",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06037 20.4184C2.84613 22.1272 2.89589 26.3251 8.64103 25.9799C8.88003 25.9655 9.1129 25.8848 9.30783 25.7378C9.64588 25.4829 9.97894 24.9601 9.69382 23.9086C9.69382 23.9086 10.5176 22.4856 9.61271 21.8843C9.61271 21.8843 9.60113 21.8108 9.72881 21.8475C9.72881 21.8475 11.3975 21.5316 12.5028 20.8232C13.2891 20.3191 13.1062 19.0622 12.212 18.8357C11.6994 18.7059 11.3471 18.845 10.6217 19.1811C10.382 19.2921 10.1359 19.3868 9.88511 19.4648C8.589 19.868 5.42109 20.6511 5.58739 18.6089C5.58739 18.6089 5.41132 16.2067 4.35534 16.0097C3.96231 15.9364 3.19328 16.2891 3.30187 16.6951C3.57495 17.7169 3.55451 18.8263 3.30619 19.4682C3.18805 19.7736 3.10172 20.0914 3.06082 20.4184H3.06037Z",
    fill: "#37C7BE",
    stroke: "#207F79",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11C8.32843 11 9 10.1046 9 9C9 7.89543 8.32843 7 7.5 7C6.67157 7 6 7.89543 6 9C6 10.1046 6.67157 11 7.5 11Z",
    fill: "#207F79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11C16.3284 11 17 10.1046 17 9C17 7.89543 16.3284 7 15.5 7C14.6716 7 14 7.89543 14 9C14 10.1046 14.6716 11 15.5 11Z",
    fill: "#207F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.e550549d645dcd655290cca27515e4ae.svg";
export { ForwardRef as ReactComponent };